import React, { useState } from "react";
import { Box, Container, IconButton, Stack, Typography } from "@mui/material";
import { LuInfo, LuX } from "react-icons/lu";
import OrderInfo from "./OrderInfo";
import { useNavigate } from "react-router-dom";

interface IHeader {
  height: string;
}

function Header({ height }: IHeader) {
  const [openOrderInfo, setOpenOrderInfo] = useState(false);
  const navigate = useNavigate();

  return (
    <>
      <OrderInfo open={openOrderInfo} onClose={() => setOpenOrderInfo(false)} />
      <Box component="header" sx={{ height, backgroundColor: "primary.main" }}>
        <Container maxWidth="sm" sx={{ width: "100%", height: "100%" }}>
          <Stack
            sx={{ height: "100%" }}
            direction="row"
            alignItems="center"
            spacing="10px"
          >
            <IconButton
              onClick={() => navigate("/fnb/tables")}
              sx={{ color: "common.white", padding: 0 }}
            >
              <LuX size={25} />
            </IconButton>
            <Typography
              variant="h3"
              sx={{ color: "common.white", flexGrow: 1 }}
            >
              Gọi món
            </Typography>
            <IconButton
              onClick={() => setOpenOrderInfo(true)}
              sx={{ color: "common.white" }}
            >
              <LuInfo size={25} />
            </IconButton>
          </Stack>
        </Container>
      </Box>
    </>
  );
}

export default Header;
